import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/utils/constants';
import { useAuth } from '@/contexts/AuthContext';

const VisitTracker = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Track page visit
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/analytics/track`, {
          path: location.pathname,
          title: document.title,
          referrer: document.referrer,
          user_id: user?.id || null,
          user_email: user?.email || null
        });
      } catch {
        // Silently fail - analytics should not break the app
      }
    };

    trackVisit();
  }, [location.pathname, user]);

  return null; // This component doesn't render anything
};

export default VisitTracker;
